/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from '@mui/material';
import {
  DefaultSelectV2,
  InputV2,
  NumberInputV2,
  TrueFalseSelectV2,
} from '../../../components/v2';
import * as selectorsProdutos from '../../../store/produto/reducer';
import { loadProdutosOptions } from '../../../store/produto/actions';
import { moneyFormatter } from '../../../utils';

export const PEDIDO_LOCAL_OPTIONS = [
  { id: 'Almoxarifado I  C17', nome: 'Almoxarifado I  C17' },
  { id: 'Almoxarifado II  C17', nome: 'Almoxarifado II  C17' },
  { id: 'Sala Drones', nome: 'Sala Drones' },
  { id: 'Sucata', nome: 'Sucata' },
];

export const emptyPedidoVinculado = (item) => ({
  produto: item?.tipoItem === 'PRODUTO' && item.idItem ? item.idItem : '',
  quantidade: item?.quantidade != null ? Number(item.quantidade) : '',
  local: '',
  fornecedor: '',
  valorUnitario: '',
  valorTotal: undefined,
});

export const calcValorTotal = (quantidade, valorUnitario) => {
  if (quantidade == null || quantidade === '' || valorUnitario == null || valorUnitario === '') {
    return undefined;
  }
  return Number(quantidade) * Number(valorUnitario);
};

const PedidoVinculadoForm = ({
  values,
  errors,
  onChange,
  produtoOptions,
  loadProdutosOptions: fetchProdutos,
}) => {
  useEffect(() => {
    fetchProdutos();
  }, [fetchProdutos]);

  const setMoney = (quantidade, valorUnitario) => {
    onChange({
      ...values,
      quantidade,
      valorUnitario,
      valorTotal: calcValorTotal(quantidade, valorUnitario),
    });
  };

  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <DefaultSelectV2
          label="Produto"
          name="produto"
          isRequired
          showEmpty
          options={produtoOptions || []}
          value={values.produto || ''}
          error={!!(errors && errors.produto)}
          onSelect={(event) => onChange({ ...values, produto: event.target.value })}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TrueFalseSelectV2
          label="Devolução de uso"
          value="false"
          disabled
          showEmpty={false}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <NumberInputV2
          label="Quantidade"
          isRequired
          error={!!(errors && errors.quantidade)}
          value={values.quantidade}
          onChange={(quantidade) => setMoney(quantidade, values.valorUnitario)}
          prefix=""
          decimalScale={0}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <DefaultSelectV2
          label="Local"
          name="local"
          isRequired
          showEmpty
          options={PEDIDO_LOCAL_OPTIONS}
          value={values.local || ''}
          error={!!(errors && errors.local)}
          onSelect={(event) => onChange({ ...values, local: event.target.value })}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <DefaultSelectV2
          label="Tipo"
          value="FORNECEDOR"
          disabled
          showEmpty={false}
          options={[{ id: 'FORNECEDOR', nome: 'Fornecedor' }]}
          onSelect={() => {}}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <InputV2
          label="Fornecedor"
          name="fornecedor"
          isRequired
          value={values.fornecedor || ''}
          error={!!(errors && errors.fornecedor)}
          onChange={(event) => onChange({ ...values, fornecedor: event.target.value })}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <NumberInputV2
          label="Valor unitário"
          isRequired
          error={!!(errors && errors.valorUnitario)}
          value={values.valorUnitario}
          onChange={(valorUnitario) => setMoney(values.quantidade, valorUnitario)}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <InputV2
          label="Valor total"
          value={moneyFormatter(values.valorTotal)}
          disabled
        />
      </Grid>
    </Grid>
  );
};

PedidoVinculadoForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  produtoOptions: PropTypes.array,
  loadProdutosOptions: PropTypes.func.isRequired,
};

PedidoVinculadoForm.defaultProps = {
  errors: {},
  produtoOptions: [],
};

const mapStateToProps = (state) => ({
  produtoOptions: selectorsProdutos.getProdutoOptions(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ loadProdutosOptions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PedidoVinculadoForm);
